import { Platform, StyleSheet, View } from 'react-native';
import React, { useEffect, useState, useRef } from 'react';
// 1. IMPORT DESCOMENTADO (Esto quita el ReferenceError)
import RNPickerSelect, { Item } from 'react-native-picker-select';
import { Icon, Text } from 'react-native-paper';

import GlobalStyles from '../../resources/Styles';
import Colors from "../../resources/Colors";
import { IFormValuesGeneric, IGenericItem } from 'src/interfaces';

interface Props {
  name: string;
  formValues: IFormValuesGeneric;
  onUpdateFormValue: (name: string, value: any) => void; // Prop necesaria para guardar datos
  label?: string;
  items: IGenericItem[];
  placeholder: string;
  errorMessage?: string[] | string;
  style?: object;
  isAutocomplete?: boolean;
  refreshParentScreen?: Function | null;
  readonly?: boolean;
};

const SelectField = ({
  name, formValues, onUpdateFormValue, label, items, placeholder,
  errorMessage = "", style = {}, isAutocomplete = false,
  refreshParentScreen = null, readonly = false
}: Props): JSX.Element => {

  // Arreglo para el error de Web 'value should not be null'
  const initialFormValue = formValues[name];
  const initialValue = isAutocomplete && initialFormValue ? (initialFormValue as IGenericItem).value : initialFormValue;
  const [value, setValue] = useState<string | number>(initialValue || ""); // "" en lugar de null

  const lastProcessedValue = useRef(initialValue); // 👈 Referencia para el control

  // 🚀 AGREGAR ESTO: Sincroniza el estado local cuando las props cambian
  useEffect(() => {
    const rawValue = isAutocomplete && formValues[name]
      ? (formValues[name] as IGenericItem).value
      : formValues[name];
  
    if (rawValue !== undefined) {
      // Guardamos siempre la versión "limpia" para el estado del Picker
      const safeValue = (rawValue !== null) ? rawValue : "";
      setValue(safeValue);
      lastProcessedValue.current = String(safeValue); 
    }
  }, [formValues[name], name]);

  // Limpiamos los items para evitar el error de 'array supplied, expected object'
  const formattedItems = items.map(item => ({
    label: item.label,
    value: item.value,
    key: String(item.value) // Agregamos la KEY para quitar el warning de React
  }));

  const selectBoxStyle = {
    inputWeb: {
      color: readonly ? Colors.grayTextButton : Colors.inputTextColor,
      width: '100%',
      border: 'none',
      backgroundColor: 'transparent',
      outline: 'none',
      fontSize: 16,
      appearance: 'none',
      cursor: readonly ? 'default' : 'pointer',
      paddingRight: 30, // 👈 Deja espacio para que el texto no tape el icono
    },
    iconContainer: { 
      top: Platform.OS === 'web' ? 0 : 15, // Ajusta según necesites
      right: 0,
      // En web, el contenedor también debe dejar pasar el clic
      pointerEvents: 'none', 
    }
  };

  const handleUpdate = (newValue: any) => {
    // Normalizamos a String: 
    // Si es null/undefined queda como "", si es número 123 queda como "123"
    const normalizedValue = (newValue !== null && newValue !== undefined) 
      ? String(newValue) 
      : "";
  
    // Comparamos contra la referencia (que también guardaremos como String)
    if (normalizedValue === String(lastProcessedValue.current)) {
      return; 
    }
  
    if (typeof onUpdateFormValue === 'function') {
      lastProcessedValue.current = normalizedValue;
      
      // Buscamos el item comparando también en formato String
      const foundItem = items.find(item => String(item.value) === normalizedValue);
      
      // Si tu API espera números para los IDs, aquí puedes decidir:
      // Si el valor es puramente numérico, lo mandamos como número, si no, como string.
      const valueToExport = isNaN(Number(normalizedValue)) || normalizedValue === ""
        ? normalizedValue 
        : Number(normalizedValue);
  
      const finalValue = isAutocomplete ? foundItem : valueToExport;
  
      onUpdateFormValue(name, finalValue);
    }
  
    if (refreshParentScreen) refreshParentScreen();
  };

  return (
    <View style={[style]}>
      {label && <Text style={styles.labelForm}>{label}</Text>}

      <View style={[
        styles.inputText,
        { maxHeight: 20, justifyContent: 'center', position: 'relative', padding: 0, border: 'transparent' },
      ]}>
        <RNPickerSelect
          style={selectBoxStyle}
          onValueChange={(val) => {
            setValue(val || "");
            if (Platform.OS !== 'ios') handleUpdate(val);
          }}
          onDonePress={() => handleUpdate(value)}
          items={formattedItems} // Usamos los items formateados
          placeholder={placeholder ? { label: placeholder, value: "" }: {}}
          value={value}
          disabled={readonly}
          useNativeAndroidPickerStyle={false}
          pickerProps={{
            id: name,
            name: name
          } as any}
          Icon={() => {
            if(!readonly){
              if (Platform.OS === "web")
                return <View style={{ justifyContent: 'center', alignItems: 'center', pointerEvents: 'none' }}>
                  <Icon size={22} source={'chevron-down'} />
                </View>;
              else
                return <Icon size={22} source={'chevron-down'} />;
            }
          }}
        />
      </View>
    </View>
  );
};

export default SelectField;

const styles = StyleSheet.create({
  ...GlobalStyles,
});